import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Select } from "components/common";
import Spinner from "components/common/Spinner";
import { useStore } from "stores/connect";
import { defaultCompare } from "logic/DefaultCompare";
import { Button, ControlLabel, FormGroup, Row, Col } from "components/bootstrap";
import ForwarderInputsStore, { ForwarderInputsActions } from "forwarder/stores/ForwarderInputsStore";
import InputProfilesStore, { InputProfilesActions } from "forwarder/stores/InputProfilesStore";
const PLACEHOLDER = "placeholder";
const LabelPlaceholder = styled.div`
  height: 25px; // label takes 20px + 5px margin
`;
const ForwarderInputDropdown = ({
  label = void 0,
  title = "",
  onLoadMessage,
  loadButtonDisabled = false,
  autoLoadMessage = false
}) => {
  const { all: inputProfiles } = useStore(InputProfilesStore);
  const [selectedInput, setSelectedInput] = useState(PLACEHOLDER);
  const [selectedInputProfileId, setSelectedInputProfileId] = useState();
  const { forwarderInputs } = useStore(ForwarderInputsStore);
  const _sortByTitle = (item1, item2) => defaultCompare(item1.title, item2.title);
  const _formatListItem = (item) => ({ value: item.id, label: item.title });
  const _onSelectedForwarderChange = (inputProfileId) => {
    const inputProfile = inputProfiles && inputProfiles.find((inputProfileItem) => inputProfileItem.id === inputProfileId);
    if (inputProfile) {
      setSelectedInputProfileId(inputProfile.id);
    }
  };
  const _onSelectedInputChange = (inputId) => {
    if (autoLoadMessage) {
      onLoadMessage(inputId);
    }
    setSelectedInput(inputId);
  };
  const _onLoadMessage = () => {
    onLoadMessage(selectedInput);
  };
  useEffect(() => {
    InputProfilesActions.listAll();
  }, []);
  useEffect(() => {
    if (selectedInputProfileId) {
      ForwarderInputsActions.listAll({ inputProfileId: selectedInputProfileId });
    }
  }, [selectedInputProfileId]);
  if (!inputProfiles) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const inputProfileOptions = inputProfiles.sort(_sortByTitle).map(_formatListItem);
  const inputs = forwarderInputs[selectedInputProfileId];
  const inputOptions = inputs && inputs.sort(_sortByTitle).map(_formatListItem);
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: autoLoadMessage ? 6 : 5 }, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "inputProfileSelect" }, label && /* @__PURE__ */ React.createElement(ControlLabel, null, label), /* @__PURE__ */ React.createElement(
    Select,
    {
      inputId: "inputProfileSelect",
      name: "inputProfileSelect",
      placeholder: "Select Input Profile",
      options: inputProfileOptions,
      onChange: _onSelectedForwarderChange,
      value: void 0
    }
  ))), /* @__PURE__ */ React.createElement(Col, { md: autoLoadMessage ? 6 : 5 }, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "input" }, label && /* @__PURE__ */ React.createElement(LabelPlaceholder, null), /* @__PURE__ */ React.createElement(
    Select,
    {
      id: "input",
      name: "input",
      placeholder: selectedInputProfileId && !inputs ? "Loading..." : "Select Input",
      disabled: !inputs,
      options: inputOptions || [],
      "aria-label": "select input",
      onChange: _onSelectedInputChange,
      value: void 0
    }
  ))), !autoLoadMessage && /* @__PURE__ */ React.createElement(Col, { md: 1 }, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "info",
      disabled: loadButtonDisabled || selectedInput === PLACEHOLDER,
      onClick: _onLoadMessage
    },
    title
  )));
};
export default ForwarderInputDropdown;
